import { Fragment, useCallback, useEffect, useState } from "react"
import UserService from "services/user.service"
import { Table } from "common/Table/Table"
import { formatDate } from "utils/funcs"
import swal from "sweetalert"
import { useNotifications } from "hooks/useNotification"
import { Modal } from "common/Modal"

const service = new UserService()

export const TNTWinners = ({ showModal, setShowModal }) => {

    const columns = [
        { key: "prizeName", dbColName: "prizeName", title: "prize Name" },
        { key: "location", dbColName: "location", title: "location" },
        { key: "winnerName", dbColName: "winnerName", title: "winner Name" },
        { key: "startDate", dbColName: "startDate", title: "start Date", render: (date) => formatDate(date) },
        { key: "endDate", dbColName: "endDate", title: "end Date", render: (date) => formatDate(date) },
        { key: "createdAt", dbColName: "createdAt", title: "created At", render: (date) => formatDate(date) },
        {
            key: "actions", title: "actions", render: (item) => (
                <div>
                    <button
                        type="button"
                        onClick={() => handleEditClick(item)}
                        className="p-2 text-xs text-blue-500 rounded-md "
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                            />
                        </svg>
                    </button>
                    <button
                        type="button"
                        className="text-right text-red-500"
                        onClick={() => handleDelete(item._id)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                            />
                        </svg>
                    </button>
                </div>

            )
        },
    ]
    const [tntWinners, setTNTWinners] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState<string | null>(null);
    const [saving, setSaving] = useState(false);
    const [state, setState] = useState({
        prizeName: "",
        location: "",
        winnerName: "",
        startDate: "",
        endDate: "",
    })
    const [pagination, setPagination] = useState({
        pageNumber: 1,
        pageSize: 10
    })

    const { successMessage, errorMessage } = useNotifications()

    const fetchData = useCallback(() => {
        setLoading(true);
        service.getTNTWinners(pagination).then((resp) => {
            setTNTWinners(resp.data.data);
            console.log(resp.data.data);
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }, [pagination])

    useEffect(() => {
        fetchData()
    }, [])

    const handleDelete = (id) => {
        swal({
            title:
                "Are you sure, you want to delete this winner, this action cannot be undone?",
            icon: "warning",
            className: "w-[500px]",
            buttons: {
                cancel: {
                    text: "Cancel",
                    visible: true,
                },
                confirm: {
                    text: "Delete",
                    className: "bg-primary text-white",
                },
            },
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                service
                    .deleteTNTWinner(id)
                    .then((resp) => {
                        successMessage("TNT Winner deleted successfully")
                        const shallowCopy = [...tntWinners]
                        const newData = shallowCopy.filter((c) => c._id !== id)
                        setTNTWinners(newData)
                    })
                    .catch((err) => {
                        errorMessage("Failed to delete TNT Winner")
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            }
        })
    }

    const calculateEndDate = (startDate: string) => {
        if (!startDate) return "";
        const date = new Date(startDate);
        date.setDate(date.getDate() + 7);
        return date.toISOString().split('T')[0];
    }

    const handleStartDateChange = (e) => {
        const startDate = e.target.value;
        const endDate = calculateEndDate(startDate);
        setState({ ...state, startDate, endDate });
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setSaving(true)

        if (isEditing && editingId) {
            service.updateTNTWinner(editingId, state).then((resp) => {
                successMessage("TNT Winner updated successfully")
                setShowModal(false)
                setIsEditing(false)
                setEditingId(null)
                setState({
                    prizeName: "",
                    location: "",
                    winnerName: "",
                    startDate: "",
                    endDate: "",
                })
                // Refresh the list
                fetchData()
            }).catch((error) => {
                errorMessage("Failed to update TNT Winner")
                console.log(error);
            }).finally(() => {
                setSaving(false)
            })
        } else {
            service.addTNTWinner(state).then((resp) => {
                successMessage("TNT Winner added successfully")
                setShowModal(false)
                setState({
                    prizeName: "",
                    location: "",
                    winnerName: "",
                    startDate: "",
                    endDate: "",
                })
                fetchData()
            }).catch((error) => {
                errorMessage("Failed to add TNT Winner")
                console.log(error);
            }).finally(() => {
                setSaving(false)
            })
        }
    }

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value })
    }

    const handleEditClick = (item) => {
        setIsEditing(true)
        setEditingId(item._id)
        setState({
            prizeName: item.prizeName || "",
            location: item.location || "",
            winnerName: item.winnerName || "",
            startDate: item.startDate ? new Date(item.startDate).toISOString().split('T')[0] : "",
            endDate: item.endDate ? new Date(item.endDate).toISOString().split('T')[0] : "",
        })
        setShowModal(true)
    }

    const handleCloseModal = () => {
        setShowModal(false)
        setIsEditing(false)
        setEditingId(null)
        setState({
            prizeName: "",
            location: "",
            winnerName: "",
            startDate: "",
            endDate: "",
        })
    }

    return (
        <Fragment>

            <Table
                data={tntWinners}
                columns={columns}
                loadingData={loading}
                totalItems={tntWinners.length}
                exportButton={false}
                handleExport={() => { }}
            />

            <Modal
                showModal={showModal}
                setShowModal={handleCloseModal}
                title={isEditing ? "Edit TNT Winner" : "Add TNT Winner"}
                width="w-full md:w-1/3"
            >
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="flex flex-col gap-1.5">
                        <label className="field-label">
                            Prize Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="prizeName"
                            value={state.prizeName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 font-light text-gray-800 border border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
                            placeholder="Enter prize name"
                        />
                    </div>

                    <div className="flex flex-col gap-1.5">
                        <label className="field-label">
                            Location <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="location"
                            value={state.location}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 font-light text-gray-800 border border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
                            placeholder="Enter location"
                        />
                    </div>

                    <div className="flex flex-col gap-1.5">
                        <label className="field-label">
                            Winner Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="winnerName"
                            value={state.winnerName}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 font-light text-gray-800 border border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
                            placeholder="Enter winner name"
                        />
                    </div>

                    <div className="flex gap-3">
                        <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
                            <label className="field-label">
                                Start Date <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="date"
                                name="startDate"
                                value={state.startDate}
                                onChange={handleStartDateChange}
                                required
                                className="w-full px-4 py-2 font-light text-gray-800 border border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
                            />
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
                            <label className="field-label">
                                End Date <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="date"
                                name="endDate"
                                value={state.endDate}
                                disabled
                                className="w-full px-4 py-2 font-light text-gray-800 border border-gray-200 rounded-md disabled:bg-gray-100 focus:border-gray-300 focus:outline-none focus:ring-0"
                            />
                        </div>
                    </div>

                    <div className="flex gap-3 pt-4">
                        <button
                            type="button"
                            onClick={handleCloseModal}
                            className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={saving}
                            className="flex-1 px-4 py-2 text-white bg-green-500 rounded-md hover:bg-green-600 disabled:bg-green-300 disabled:cursor-not-allowed transition-colors"
                        >
                            {saving ? (isEditing ? "Updating..." : "Adding...") : (isEditing ? "Update" : "Add")}
                        </button>
                    </div>
                </form>
            </Modal>
        </Fragment>
    );
};